import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Cài đặt thủ tục nhập học", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-5" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header border-0 pt-2" }
const _hoisted_14 = { class: "card-title d-flex flex-column align-items-start" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-1" }, "Danh sách điều kiện miễn giảm Tiếng Anh", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, "Chứng chỉ / điểm THPT đạt ngưỡng nào thì được miễn những học phần Tiếng Anh nào.", -1)
const _hoisted_17 = { class: "filter-slim d-flex flex-wrap align-items-center gap-3 mt-3" }
const _hoisted_18 = { class: "d-flex align-items-center position-relative" }
const _hoisted_19 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1)
const _hoisted_21 = { class: "card-toolbar" }
const _hoisted_22 = {
  class: "justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_23 = { class: "svg-icon svg-icon-2" }
const _hoisted_24 = { class: "svg-icon svg-icon-2" }
const _hoisted_25 = {
  type: "button",
  class: "btn btn-sm btn-light-primary d-none",
  "data-bs-toggle": "modal",
  ref: "kt_modal_add_combination",
  "data-bs-target": "#kt_modal_add_combination"
}
const _hoisted_26 = { class: "card-body umt-form pt-0" }
const _hoisted_27 = { class: "fw-semibold text-gray-800" }
const _hoisted_28 = { class: "d-flex align-items-center flex-wrap gap-2 mt-1" }
const _hoisted_29 = { class: "text-muted fs-7" }
const _hoisted_30 = {
  key: 0,
  class: "badge badge-light-primary fs-8"
}
const _hoisted_31 = { class: "badge badge-light fs-8" }
const _hoisted_32 = {
  key: 1,
  class: "badge badge-light-warning fs-8",
  title: "Phải thỏa TẤT CẢ điều kiện bên dưới"
}
const _hoisted_33 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_34 = {
  key: 1,
  class: "text-muted fs-7"
}
const _hoisted_35 = {
  key: 0,
  class: "text-muted fs-8 fst-italic mb-1"
}
const _hoisted_36 = {
  key: 0,
  class: "text-muted fs-8 text-nowrap",
  style: {"min-width":"76px"}
}
const _hoisted_37 = { class: "fw-bold text-gray-800 text-nowrap" }
const _hoisted_38 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_39 = ["title"]
const _hoisted_40 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_41 = { class: "badge badge-light-success fs-8" }
const _hoisted_42 = { class: "text-gray-700 fs-7 text-truncate mw-300px" }
const _hoisted_43 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_44 = {
  key: 2,
  class: "fs-7 mt-1"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Học tiếp:", -1)
const _hoisted_46 = { class: "text-gray-800 fw-semibold ms-1" }
const _hoisted_47 = { class: "d-flex flex-center gap-2" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-6" }, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-files fs-6 text-gray-600" }, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-6" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  class: "modal fade",
  id: "kt_modal_add_combination",
  ref: "addCombinationModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = {
  class: "modal-header py-4 px-6",
  id: "kt_modal_add_customer_header"
}
const _hoisted_61 = { class: "d-flex flex-column" }
const _hoisted_62 = { class: "fw-bolder fs-4 mb-0" }
const _hoisted_63 = { class: "text-muted fs-8 fst-italic mt-1" }
const _hoisted_64 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_65 = { class: "svg-icon svg-icon-1" }
const _hoisted_66 = { class: "modal-body umt-form py-5 px-6" }
const _hoisted_67 = { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "1", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Thông tin chứng chỉ", -1)
const _hoisted_70 = { class: "ms-auto" }
const _hoisted_71 = { class: "row g-3 mb-4" }
const _hoisted_72 = { class: "col-6 col-lg-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Mã chứng chỉ", -1)
const _hoisted_74 = { class: "col-6 col-lg-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Tên chứng chỉ", -1)
const _hoisted_76 = { class: "col-6 col-lg-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, [
  /*#__PURE__*/_createTextVNode("Chương trình áp dụng "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(trống = tất cả)")
], -1)
const _hoisted_78 = { class: "col-6 col-lg-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Loại", -1)
const _hoisted_80 = { class: "col-12 col-lg-6" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, [
  /*#__PURE__*/_createTextVNode("Biến thể thang điểm "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(trống nếu chứng chỉ chỉ có 1 thang)")
], -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Chỉ để phân nhóm & hiển thị — không tham gia so ngưỡng điểm.", -1)
const _hoisted_83 = { class: "col-12" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Mô tả", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2 pb-2 mb-3 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "2"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Ngưỡng điểm"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, "— đạt từ \"nhỏ nhất\" đến dưới \"lớn nhất\" thì được miễn giảm")
], -1)
const _hoisted_86 = { class: "umt-sub-indent" }
const _hoisted_87 = { class: "d-flex align-items-start gap-3 mb-5 wrap-item-condition" }
const _hoisted_88 = { class: "d-flex flex-column flex-center min-w-25px mw-25px" }
const _hoisted_89 = { class: "badge badge-circle bg-primary" }
const _hoisted_90 = { class: "d-flex gap-2 flex-center w-100" }
const _hoisted_91 = { class: "d-flex flex-wrap gap-3 w-100" }
const _hoisted_92 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_93 = { class: "fv-row" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Giá trị nhỏ nhất (>=)", -1)
const _hoisted_95 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_96 = { class: "fv-row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Giá trị lớn nhất (" + /*#__PURE__*/_toDisplayString(`<`) + ")", -1)
const _hoisted_98 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_99 = { class: "fv-row" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Loại", -1)
const _hoisted_101 = {
  key: 0,
  class: ""
}
const _hoisted_102 = ["onClick"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-danger bi bi-trash fs-6 p-0 m-0" })
], -1)
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle bg-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-3 p-0 m-0" })
], -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2 pb-2 mb-3 mt-5 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "3"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Môn miễn giảm"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, "— học phần được miễn khi thỏa ngưỡng ở trên")
], -1)
const _hoisted_107 = { class: "umt-sub-indent" }
const _hoisted_108 = { class: "d-flex align-items-start gap-3 mb-5 wrap-item-condition" }
const _hoisted_109 = { class: "d-flex flex-column flex-center min-w-25px mw-25px" }
const _hoisted_110 = { class: "badge badge-circle bg-primary" }
const _hoisted_111 = { class: "d-flex gap-2 flex-center w-100" }
const _hoisted_112 = { class: "d-flex flex-wrap gap-3 w-100" }
const _hoisted_113 = { class: "w-150px" }
const _hoisted_114 = { class: "fv-row" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Mã môn", -1)
const _hoisted_116 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_117 = { class: "fv-row" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Tên môn", -1)
const _hoisted_119 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_120 = { class: "fv-row" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Mô tả", -1)
const _hoisted_122 = ["onUpdate:modelValue"]
const _hoisted_123 = { class: "w-150px" }
const _hoisted_124 = { class: "fv-row" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Giá trị", -1)
const _hoisted_126 = { class: "" }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = /*#__PURE__*/_createElementVNode("span", { class: "" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-danger bi bi-trash fs-6 p-0 m-0" })
], -1)
const _hoisted_129 = [
  _hoisted_128
]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle bg-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus text-white fs-3 p-0 m-0" })
], -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-2 pb-2 mb-3 mt-5 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "4"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-gray-600 text-uppercase" }, "Môn học tiếp theo"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, "— học phần thí sinh phải học tiếp (tính thêm vào học phí)")
], -1)
const _hoisted_132 = { class: "umt-sub-indent" }
const _hoisted_133 = { class: "w-150px" }
const _hoisted_134 = { class: "fv-row" }
const _hoisted_135 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_136 = { class: "fv-row" }
const _hoisted_137 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_138 = { class: "fv-row" }
const _hoisted_139 = ["onUpdate:modelValue"]
const _hoisted_140 = { class: "w-150px" }
const _hoisted_141 = { class: "fv-row" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-4" }, null, -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end gap-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32",
    "data-bs-dismiss": "modal"
  }, "Hủy"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-1" }),
    /*#__PURE__*/_createTextVNode("Lưu ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
          ]),
          _hoisted_9,
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/caidatthutucnhaphoc",
              class: "text-muted text-hover-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cài đặt thủ tục nhập học ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_11,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyFilter())),
                  class: "form-control w-250px ps-11",
                  style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"},
                  placeholder: "Tìm tên, mã chứng chỉ, môn..."
                }, null, 544), [
                  [_vModelText, _ctx.search]
                ])
              ]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterType) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.applyFilter())),
                "popper-class": "filter-slim-dd",
                class: "form-select-solid",
                style: {"width":"150px"},
                placeholder: "— Loại —"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Loại —",
                    value: ""
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrType, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.filterProgram,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterProgram) = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.applyFilter())),
                "popper-class": "filter-slim-dd",
                class: "form-select-solid",
                style: {"width":"170px"},
                placeholder: "— Chương trình —"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "— Chương trình —",
                    value: ""
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsPrograms, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.search || _ctx.filterType || _ctx.filterProgram)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-light",
                    title: "Đặt lại toàn bộ bộ lọc",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.search = ''; _ctx.filterType = ''; _ctx.filterProgram = ''; _ctx.applyFilter()})
                  }, [
                    _hoisted_20,
                    _createTextVNode("Đặt lại ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "btn btn-success me-3",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.exportFile && _ctx.exportFile(...args)))
              }, [
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil021.svg" })
                ]),
                _createTextVNode(" Xuất Excel ")
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.callModalAddApp && _ctx.callModalAddApp(...args)))
              }, [
                _createElementVNode("span", _hoisted_24, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm điều kiện ")
              ]),
              _createElementVNode("button", _hoisted_25, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            total: _ctx.tableData.length,
            currentPage: _ctx.pagination.currentPage,
            "table-header": _ctx.tableHeader,
            "rows-per-page": _ctx.pagination.limit,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-certificateName": _withCtx(({ row: customer }) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(customer.certificateName), 1),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(customer.certificateCode || '—'), 1),
                  (customer.variantLabel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(customer.variantLabel), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.arrType.find(t => t.value == customer.type)?.label || '—'), 1),
                  (customer.ismulticriteria)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Multi ĐK"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            "cell-appliedprograms": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_33, [
                ((customer.appliedprograms || []).length && customer.appliedprograms.length < _ctx.optionsPrograms.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(customer.appliedprograms, (p) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: p,
                        class: "badge badge-light-primary fs-8"
                      }, _toDisplayString(_ctx.optionsPrograms.find(o => o.value == p)?.label || p), 1))
                    }), 128))
                  : (_openBlock(), _createElementBlock("span", _hoisted_34, "Tất cả"))
              ])
            ]),
            "cell-minScore": _withCtx(({ row: customer }) => [
              (_ctx.sortedCriteria(customer).length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.sortedCriteria(customer).length > 1 ? 'ps-3 border-start border-2 border-gray-300' : '')
                  }, [
                    (_ctx.sortedCriteria(customer).length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, "thỏa tất cả"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedCriteria(customer), (c, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "d-flex align-items-baseline gap-2"
                      }, [
                        (c.type)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.optionsTypeCondition.find(o => o.value == c.type)?.label || c.type), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(c.min) + " – " + _toDisplayString(c.max), 1)
                      ]))
                    }), 128))
                  ], 2))
                : (_openBlock(), _createElementBlock("span", _hoisted_38, "—"))
            ]),
            "cell-freeSubjects": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                title: (customer.courseexemptions || []).map(i => `${i.name}${i.value ? ' (' + i.value + ')' : ''}`).join('\n')
              }, [
                ((customer.courseexemptions || []).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, "Miễn " + _toDisplayString(customer.courseexemptions.length) + " môn", 1),
                      _createElementVNode("span", _hoisted_42, [
                        _createTextVNode(_toDisplayString(customer.courseexemptions.slice(0, 2).map(i => i.name).join(' · ')), 1),
                        (customer.courseexemptions.length > 2)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" …")
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_43, "—")),
                ((customer.nextlevel || []).filter(i => i.code).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("span", _hoisted_46, _toDisplayString((customer.nextlevel || []).filter(i => i.code).map(i => i.name || i.code).join(', ')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_39)
            ]),
            "cell-actions": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-icon btn-light-primary",
                  title: "Chỉnh sửa điều kiện",
                  onClick: ($event: any) => (_ctx.setDataForm(customer))
                }, _hoisted_50, 8, _hoisted_48),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-icon btn-light",
                  title: "Nhân bản thành điều kiện mới",
                  onClick: ($event: any) => (_ctx.duplicateRow(customer))
                }, _hoisted_53, 8, _hoisted_51),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-icon btn-light-danger",
                  title: "Xóa điều kiện",
                  onClick: ($event: any) => (_ctx.deleteRow(customer))
                }, _hoisted_56, 8, _hoisted_54)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("h2", _hoisted_62, _toDisplayString(_ctx.isEdit ? "Chỉnh sửa điều kiện" : "Thêm điều kiện"), 1),
              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.isEdit && _ctx.formData.certificateName ? _ctx.formData.certificateName : 'Ngưỡng điểm chứng chỉ / THPT và các học phần Tiếng Anh được miễn'), 1)
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("span", _hoisted_65, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              ref: "formRef",
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _hoisted_69,
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_el_checkbox, {
                        class: "umt-flag-chip",
                        id: "ismulticriteria",
                        value: 1,
                        modelValue: _ctx.formData.ismulticriteria,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.ismulticriteria) = $event)),
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.checkMultiForm($event))),
                        label: "Multi điều kiện",
                        title: "Bật = thí sinh phải thỏa TẤT CẢ điều kiện ở mục 2 (vd nghe-đọc + viết + nói)"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createVNode(_component_el_form_item, { prop: "certificateCode" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "VD: APTIS",
                            modelValue: _ctx.formData.certificateCode,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.certificateCode) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _hoisted_75,
                      _createVNode(_component_el_form_item, { prop: "certificateName" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "VD: APTIS ESOL General",
                            modelValue: _ctx.formData.certificateName,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.certificateName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createVNode(_component_el_form_item, { prop: "appliedprograms" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            modelValue: _ctx.formData.appliedprograms,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.appliedprograms) = $event)),
                            multiple: "",
                            clearable: "",
                            "collapse-tags": "",
                            class: "form-select-solid w-100",
                            placeholder: "Tất cả chương trình"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsPrograms, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _createVNode(_component_el_select, {
                        "popper-class": "umt-form-dd",
                        modelValue: _ctx.formData.type,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.type) = $event)),
                        class: "form-select-solid w-100",
                        placeholder: "Loại"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrType, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _createVNode(_component_el_form_item, { prop: "variantLabel" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "form-select-solid w-100",
                            placeholder: "VD: TOEFL iBT trước 01/2026",
                            modelValue: _ctx.formData.variantLabel,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.variantLabel) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _hoisted_82
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-textarea w-100",
                        rows: "2",
                        placeholder: "Mô tả ngắn hiển thị cho thí sinh",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.description) = $event))
                      }, "\n                                    ", 512), [
                        [_vModelText, _ctx.formData.description]
                      ])
                    ])
                  ]),
                  _hoisted_85,
                  _createElementVNode("div", _hoisted_86, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrCondition, (row, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("span", _hoisted_89, _toDisplayString(index+1), 1)
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              (_ctx.arrCondition.length > 1)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["text-primary", {'opacity-0': index == 0}])
                                  }, "And", 2))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", _hoisted_93, [
                                  _hoisted_94,
                                  _createVNode(_component_el_input, {
                                    class: "form-select-solid w-100",
                                    placeholder: "Giá trị nhỏ nhất",
                                    modelValue: row.min,
                                    "onUpdate:modelValue": ($event: any) => ((row.min) = $event),
                                    onKeypress: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isNumber($event)))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _hoisted_97,
                                  _createVNode(_component_el_input, {
                                    class: "form-select-solid w-100",
                                    placeholder: "Giá trị lớn nhất",
                                    modelValue: row.max,
                                    "onUpdate:modelValue": ($event: any) => ((row.max) = $event),
                                    onKeypress: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isNumber($event)))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_98, [
                                _createElementVNode("div", _hoisted_99, [
                                  _hoisted_100,
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    modelValue: row.type,
                                    "onUpdate:modelValue": ($event: any) => ((row.type) = $event),
                                    class: "form-select-solid w-100",
                                    placeholder: "Loại",
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsTypeCondition, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-30px pt-8", {'opacity-0': index == 0}])
                            }, [
                              (!_ctx.formData.ismulticriteria)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.removeRow(index)),
                                      type: "button",
                                      class: "btn btn-sm btn-link d-cell-hover"
                                    }, _hoisted_104, 8, _hoisted_102)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ])
                      ]))
                    }), 128)),
                    (!_ctx.formData.ismulticriteria)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addNewRow && _ctx.addNewRow(...args))),
                          class: "me-auto btn btn-sm btn-link d-flex gap-2 flex-center text-primary"
                        }, [
                          _hoisted_105,
                          _createTextVNode(" Thêm điều kiện")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_106,
                  _createElementVNode("div", _hoisted_107, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrSubject, (row, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_108, [
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("span", _hoisted_110, _toDisplayString(index+1), 1)
                          ]),
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("div", _hoisted_113, [
                                _createElementVNode("div", _hoisted_114, [
                                  _hoisted_115,
                                  _createVNode(_component_el_input, {
                                    class: "form-select-solid w-100",
                                    placeholder: "Mã môn",
                                    modelValue: row.code,
                                    "onUpdate:modelValue": ($event: any) => ((row.code) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_116, [
                                _createElementVNode("div", _hoisted_117, [
                                  _hoisted_118,
                                  _createVNode(_component_el_input, {
                                    class: "form-select-solid w-100",
                                    placeholder: "Tên môn",
                                    modelValue: row.name,
                                    "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_119, [
                                _createElementVNode("div", _hoisted_120, [
                                  _hoisted_121,
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "form-textarea w-100",
                                    rows: "1",
                                    placeholder: "Mô tả",
                                    "onUpdate:modelValue": ($event: any) => ((row.description) = $event)
                                  }, "\n                                                    ", 8, _hoisted_122), [
                                    [_vModelText, row.description]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("div", _hoisted_124, [
                                  _hoisted_125,
                                  _createVNode(_component_el_input, {
                                    class: "form-select-solid w-100",
                                    placeholder: "Giá trị giảm",
                                    modelValue: row.value,
                                    "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                                    onKeypress: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isNumber($event))),
                                    onKeyup: e=> {
                                                            row.value = _ctx.formatCurrentMoney(e,row.value)
                                                        }
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["w-30px pt-8", {'opacity-0': index == 0}])
                            }, [
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.removeRowSubject(index)),
                                  type: "button",
                                  class: "btn btn-sm btn-link d-cell-hover"
                                }, _hoisted_129, 8, _hoisted_127)
                              ])
                            ], 2)
                          ])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addNewRowSubject && _ctx.addNewRowSubject(...args))),
                      class: "me-auto btn btn-sm btn-link d-flex gap-2 flex-center text-primary"
                    }, [
                      _hoisted_130,
                      _createTextVNode(" Thêm môn giảm")
                    ])
                  ]),
                  _hoisted_131,
                  _createElementVNode("div", _hoisted_132, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.nextlevel, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex flex-wrap gap-3 w-100",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_133, [
                          _createElementVNode("div", _hoisted_134, [
                            _createElementVNode("label", {
                              class: _normalizeClass(`form-label fw-bolder ${index == 0?'required':''}`)
                            }, "Mã môn", 2),
                            _createVNode(_component_el_input, {
                              class: "form-select-solid w-100",
                              placeholder: "Mã môn",
                              modelValue: item.code,
                              "onUpdate:modelValue": ($event: any) => ((item.code) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("label", {
                              class: _normalizeClass(`form-label fw-bolder ${index == 0?'required':''}`)
                            }, "Tên môn", 2),
                            _createVNode(_component_el_input, {
                              class: "form-select-solid w-100",
                              placeholder: "Tên môn",
                              modelValue: item.name,
                              "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("div", _hoisted_138, [
                            _createElementVNode("label", {
                              class: _normalizeClass(`form-label fw-bolder ${index == 0?'required':''}`)
                            }, "Mô tả", 2),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-textarea w-100",
                              rows: "1",
                              placeholder: "Mô tả",
                              "onUpdate:modelValue": ($event: any) => ((item.description) = $event)
                            }, "\n                                            ", 8, _hoisted_139), [
                              [_vModelText, item.description]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("label", {
                              class: _normalizeClass(`form-label fw-bolder ${index == 0?'required':''}`)
                            }, "Giá trị", 2),
                            _createVNode(_component_el_input, {
                              class: "form-select-solid w-100",
                              placeholder: "Giá trị giảm",
                              modelValue: item.value,
                              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                              onKeypress: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isNumber($event))),
                              onKeyup: e=> {
                                                    item.value = _ctx.formatCurrentMoney(e,item.value)
                                                }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _hoisted_142,
                  _hoisted_143
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}